import script from "./ModuleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleView.vue?vue&type=script&setup=true&lang=js"

import "./ModuleView.vue?vue&type=style&index=0&id=1a145ec9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a145ec9"]])

export default __exports__